import request from "@/utils/request";

/**
 * 添加云运动用户
 * @param data 云运动用户信息
 */
export async function addYunUser(data) {
  const res = await request.post("/yun", data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 查询云运动用户列表
 * @param params 查询条件
 */
export async function listYunUser(params) {
  const res = await request.get("/yun", {
    params,
  });
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 删除云运动用户
 * @param id 用户id
 */
export async function removeYunUser(id) {
  const res = await request.delete("/yun/" + id);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 查询单个用户
 * @param id 用户id
 */
export async function getYunUser(uin) {
  const res = await request.get("/yun/" + uin);
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 修改信息表
 * @param data 信息表信息
 */
export async function updateYun(data) {
  const res = await request.put("/yun", data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}
/**
 * 查询单个用户
 * @param id 用户id
 */
export async function getLogs(params) {
  const res = await request.get("/yun/logs", {
    params,
  });
  if (res.data.code === 0) {
    return res.data.data;
  }
  return Promise.reject(new Error(res.data.message));
}

/**
 * 执行跑步任务
 * @param id 用户id
 * @param runType 任务类型
 */
export async function runTask(data) {
  const res = await request.post("/yun/run", data);
  if (res.data.code === 0) {
    return res.data.message;
  }
  return Promise.reject(new Error(res.data.message));
}
